import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "vendor/components/Grid/GridItem.jsx";
import GridContainer from "vendor/components/Grid/GridContainer.jsx";
import CustomTextField from "vendor/components/CustomTextField/CustomTextField.jsx"
import Button from "vendor/components/CustomButtons/Button.jsx";
import Card from "vendor/components/Card/Card.jsx";
import CardHeader from "vendor/components/Card/CardHeader.jsx";
import CardBody from "vendor/components/Card/CardBody.jsx";
import CardFooter from "vendor/components/Card/CardFooter.jsx";
import UploadDocumentImage from './UploadDocumentImage';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { darkBlueColor } from "utils/Constants"
import { uploadFile, editAdvert, deleteUploadImage } from "Pages/Advertisements/actions/advertisements"

import { connect } from 'react-redux';
import { BASE_URL } from "../../../utils/Constants";


class EditAdvertismentsForm extends React.Component {

    state = {
        id: 1,
        number: 1,
        start_date: null,
        end_date: null,
        required_documents: {},
        adImage: null,
        adVideo: null,
        time: null,
        title: null,
        link: null,
        adId: -1,
        status: false,
    }

    changeStatus = () => { this.setState({ status: !this.state.status }) };

    linkChangeHandler = (event) => {
        this.setState({ link: event.target.value });
    }

    timeChangeHandler = (event) => {
        this.setState({ time: event.target.value });
    }

    titleChangeHandler = (event) => {
        this.setState({ title: event.target.value });
    }

    componentWillMount() {
        const { advert } = this.props;
        this.setState({
            link: advert.link_url,
            time: advert.show_after,
            title: advert.title,
            adId: advert.id,
            adImage: advert.image,
            adVideo: advert.video,
            status: advert.is_active
        })
    }


    addRoundHandler = () => {
        const { uploadFileObject } = this.props;
        const { title, link, time, adImage, adVideo, adId, status } = this.state;
        let data;
        if (uploadFileObject) {
            if (uploadFileObject.isVideo) {
                data = {
                    id: adId,
                    position_id: this.props.advertId,
                    is_active: status,
                    title: title,
                    link_url: link,
                    show_after: time,
                    image: null,
                    video: uploadFileObject,
                }
            } else {
                data = {
                    id: adId,
                    position_id: this.props.advertId,
                    is_active: status,
                    title: title,
                    link_url: link,
                    show_after: time,
                    image: uploadFileObject,
                    video: null,
                }
            }
        } else if (adVideo) {
            data = {
                id: adId,
                position_id: this.props.advertId,
                is_active: status,
                title: title,
                link_url: link,
                show_after: time,
                image: null,
                video: adVideo,
            }
        } else if (adImage) {
            data = {
                id: adId,
                position_id: this.props.advertId,
                is_active: status,
                title: title,
                link_url: link,
                show_after: time,
                image: adImage,
                video: null,
            }
        }

        this.props.editAdvert(data)
        this.props.deleteUploadImage();
        this.props.onClose()
    }


    addDocumentImage = (event, context, property) => {

        if (!event.target.files) {
            return
        }

        var files = event.target.files;

        this.props.uploadFile(files[0]);

        for (var index = 0; index < files.length; index++) {
            var reader = new FileReader();
            reader.readAsDataURL(files[index]);
            reader.onload = function (event) {
                var image = event.target.result;
                this.setState({ adImage: image });
                image = image.slice(image.indexOf(',') + 1);

            }.bind(this);



        }
    }

    render() {
        const { classes, title } = this.props;
        return (
            <div>
                <GridContainer className={classes.container}>
                    <Card className={classes.card}>
                        <CardHeader color="warning" className={classes.cardHeader}>
                            <h4 className={classes.cardTitle}>Edit {title}</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={4}>
                                    <CustomTextField
                                        inputType="text"
                                        labelText="Link"
                                        id="link"
                                        inputProps={{
                                            value: this.state.link,
                                            onChange: (event) => this.numberChangeHandler(event)
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                    <CustomTextField
                                        inputType="number"
                                        labelText="Time in seconds"
                                        id="time"
                                        inputProps={{
                                            value: this.state.time,
                                            onChange: (event) => this.timeChangeHandler(event)
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                    <CustomTextField
                                        inputType="title"
                                        labelText="Title"
                                        id="title"
                                        inputProps={{
                                            value: this.state.title,
                                            onChange: (event) => this.titleChangeHandler(event)
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer>
                                <FormControlLabel
                                    control={<Checkbox
                                        checked={this.state.status}
                                        onChange={this.changeStatus}
                                        color="primary"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        name="status" />}
                                    label="Status"
                                    style={{ paddingLeft: "1rem" }}
                                />
                                <GridItem xs={12} sm={12} md={12}>
                                    <UploadDocumentImage
                                        image={this.state.adImage.url ? BASE_URL + this.state.adImage.url : this.state.adImage}
                                        description={"Advertisement"}
                                        onChange={(event) => this.addDocumentImage(event, "required_documents", "id_card_front")}
                                    />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            <Button
                                onClick={this.addRoundHandler}
                                color="success">
                                Edit
                            </Button>
                        </CardFooter>
                    </Card>
                </GridContainer>
            </div>
        );
    };

}

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitle: {
        color: darkBlueColor,
        fontWeight: "700",
        marginTop: "0px",
        minHeight: "auto",
        marginBottom: "3px",
        textDecoration: "none"
    },
    card: {
        alignItems: "center",
        justifyContent: "center",
        flexGrow: "0",
        flexBasis: "100%"
    },
    container: {
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginTop: "-5rem"
    },
    cardHeader: {
        width: "100%",
    },
    selectItem: {
        display: "flex",
        alignItems: "center",
    }
};

const mapStateToProps = state => {
    return {
        uploadFileObject: state.advertisement.uploadFile
    }
}
const mapDispatchToProps = dispatch => {
    return {
        uploadFile: data => dispatch(uploadFile(data)),
        editAdvert: data => dispatch(editAdvert(data)),
        deleteUploadImage: data => dispatch(deleteUploadImage()),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditAdvertismentsForm));
